export default __webpack_public_path__ + "static/media/macbook.af05733f.png";